/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragment = { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, emailTemplateId?: string | null, sourceTypeFilter?: Array<string> | null, recipientUserId?: string | null, pdfTitle?: string | null };

export type OrganisationWorkflowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationWorkflowsQuery = { organisationWorkflows: Array<{ __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, emailTemplateId?: string | null, sourceTypeFilter?: Array<string> | null, recipientUserId?: string | null, pdfTitle?: string | null }> };

export type SetOrganisationWorkflowActiveMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ID']['input'];
  active: Types.Scalars['Boolean']['input'];
}>;


export type SetOrganisationWorkflowActiveMutation = { setOrganisationWorkflowActive: { __typename: 'SetOrganisationWorkflowActiveResult', workflow: { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, emailTemplateId?: string | null, sourceTypeFilter?: Array<string> | null, recipientUserId?: string | null, pdfTitle?: string | null } } };

export type ModifyOrganisationWorkflowSettingsMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ID']['input'];
  input: Types.ModifyOrganisationWorkflowSettingsInput;
}>;


export type ModifyOrganisationWorkflowSettingsMutation = { modifyOrganisationWorkflowSettings: { __typename: 'ModifyOrganisationWorkflowSettingsResult', workflow: { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, emailTemplateId?: string | null, sourceTypeFilter?: Array<string> | null, recipientUserId?: string | null, pdfTitle?: string | null } } };

export type CreateOrganisationWorkflowMutationVariables = Types.Exact<{
  input: Types.CreateOrganisationWorkflowInput;
}>;


export type CreateOrganisationWorkflowMutation = { createOrganisationWorkflow: { __typename: 'CreateOrganisationWorkflowResult', workflow: { __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, emailTemplateId?: string | null, sourceTypeFilter?: Array<string> | null, recipientUserId?: string | null, pdfTitle?: string | null } } };

export type DeleteOrganisationWorkflowMutationVariables = Types.Exact<{
  workflowId: Types.Scalars['ID']['input'];
}>;


export type DeleteOrganisationWorkflowMutation = { deleteOrganisationWorkflow: { __typename: 'DeleteOrganisationWorkflowResult', success: boolean } };

export const OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc = gql`
    fragment OrganisationAutomatedWorkflowsBox_OrganisationWorkflow on OrganisationWorkflow {
  id
  workflowType
  description
  active
  emailTemplateId
  sourceTypeFilter
  recipientUserId
  pdfTitle
}
    `;
export const OrganisationWorkflowsDocument = gql`
    query OrganisationWorkflows {
  organisationWorkflows {
    ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;

/**
 * __useOrganisationWorkflowsQuery__
 *
 * To run a query within a React component, call `useOrganisationWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>(OrganisationWorkflowsDocument, options);
      }
export function useOrganisationWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>(OrganisationWorkflowsDocument, options);
        }
export function useOrganisationWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>(OrganisationWorkflowsDocument, options);
        }
export type OrganisationWorkflowsQueryHookResult = ReturnType<typeof useOrganisationWorkflowsQuery>;
export type OrganisationWorkflowsLazyQueryHookResult = ReturnType<typeof useOrganisationWorkflowsLazyQuery>;
export type OrganisationWorkflowsSuspenseQueryHookResult = ReturnType<typeof useOrganisationWorkflowsSuspenseQuery>;
export type OrganisationWorkflowsQueryResult = Apollo.QueryResult<OrganisationWorkflowsQuery, OrganisationWorkflowsQueryVariables>;
export const SetOrganisationWorkflowActiveDocument = gql`
    mutation SetOrganisationWorkflowActive($workflowId: ID!, $active: Boolean!) {
  setOrganisationWorkflowActive(workflowId: $workflowId, active: $active) {
    workflow {
      ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
    }
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;
export type SetOrganisationWorkflowActiveMutationFn = Apollo.MutationFunction<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>;

/**
 * __useSetOrganisationWorkflowActiveMutation__
 *
 * To run a mutation, you first call `useSetOrganisationWorkflowActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganisationWorkflowActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganisationWorkflowActiveMutation, { data, loading, error }] = useSetOrganisationWorkflowActiveMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetOrganisationWorkflowActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>(SetOrganisationWorkflowActiveDocument, options);
      }
export type SetOrganisationWorkflowActiveMutationHookResult = ReturnType<typeof useSetOrganisationWorkflowActiveMutation>;
export type SetOrganisationWorkflowActiveMutationResult = Apollo.MutationResult<SetOrganisationWorkflowActiveMutation>;
export type SetOrganisationWorkflowActiveMutationOptions = Apollo.BaseMutationOptions<SetOrganisationWorkflowActiveMutation, SetOrganisationWorkflowActiveMutationVariables>;
export const ModifyOrganisationWorkflowSettingsDocument = gql`
    mutation ModifyOrganisationWorkflowSettings($workflowId: ID!, $input: ModifyOrganisationWorkflowSettingsInput!) {
  modifyOrganisationWorkflowSettings(workflowId: $workflowId, input: $input) {
    workflow {
      ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
    }
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;
export type ModifyOrganisationWorkflowSettingsMutationFn = Apollo.MutationFunction<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>;

/**
 * __useModifyOrganisationWorkflowSettingsMutation__
 *
 * To run a mutation, you first call `useModifyOrganisationWorkflowSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganisationWorkflowSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganisationWorkflowSettingsMutation, { data, loading, error }] = useModifyOrganisationWorkflowSettingsMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyOrganisationWorkflowSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>(ModifyOrganisationWorkflowSettingsDocument, options);
      }
export type ModifyOrganisationWorkflowSettingsMutationHookResult = ReturnType<typeof useModifyOrganisationWorkflowSettingsMutation>;
export type ModifyOrganisationWorkflowSettingsMutationResult = Apollo.MutationResult<ModifyOrganisationWorkflowSettingsMutation>;
export type ModifyOrganisationWorkflowSettingsMutationOptions = Apollo.BaseMutationOptions<ModifyOrganisationWorkflowSettingsMutation, ModifyOrganisationWorkflowSettingsMutationVariables>;
export const CreateOrganisationWorkflowDocument = gql`
    mutation CreateOrganisationWorkflow($input: CreateOrganisationWorkflowInput!) {
  createOrganisationWorkflow(input: $input) {
    workflow {
      ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
    }
  }
}
    ${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;
export type CreateOrganisationWorkflowMutationFn = Apollo.MutationFunction<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>;

/**
 * __useCreateOrganisationWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationWorkflowMutation, { data, loading, error }] = useCreateOrganisationWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>(CreateOrganisationWorkflowDocument, options);
      }
export type CreateOrganisationWorkflowMutationHookResult = ReturnType<typeof useCreateOrganisationWorkflowMutation>;
export type CreateOrganisationWorkflowMutationResult = Apollo.MutationResult<CreateOrganisationWorkflowMutation>;
export type CreateOrganisationWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationWorkflowMutation, CreateOrganisationWorkflowMutationVariables>;
export const DeleteOrganisationWorkflowDocument = gql`
    mutation DeleteOrganisationWorkflow($workflowId: ID!) {
  deleteOrganisationWorkflow(workflowId: $workflowId) {
    success
  }
}
    `;
export type DeleteOrganisationWorkflowMutationFn = Apollo.MutationFunction<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>;

/**
 * __useDeleteOrganisationWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationWorkflowMutation, { data, loading, error }] = useDeleteOrganisationWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDeleteOrganisationWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>(DeleteOrganisationWorkflowDocument, options);
      }
export type DeleteOrganisationWorkflowMutationHookResult = ReturnType<typeof useDeleteOrganisationWorkflowMutation>;
export type DeleteOrganisationWorkflowMutationResult = Apollo.MutationResult<DeleteOrganisationWorkflowMutation>;
export type DeleteOrganisationWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationWorkflowMutation, DeleteOrganisationWorkflowMutationVariables>;